<template>
    <div>
        <div class="my-content-tabs my-content-1">
            <el-button class="add-btn" type="primary" size="small" @click="showAppDialog">新建项目</el-button>
            <el-table :data="articleList" style="width: 100%">
                <el-table-column prop="name" label="项目名称">
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间">
                </el-table-column>
                <el-table-column prop="mtime" label="更新时间">
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size="small" @click="toEditPage(scope.row)">创作</el-button>
                            <el-button type="primary" size="small" @click="showAppDialog(scope.row)">编辑</el-button>
                            <el-button type="danger" size="small" @click="deleteArticle(scope.row)">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :current-page="params.page" :total="total"
                @current-change="pageChange">
            </el-pagination>
        </div>
        <el-dialog title="项目信息" :visible.sync="addVisible" width="450px">
            <el-form :model="params" label-width="80px">
                <el-form-item label="项目名称">
                    <el-input size="small" v-model="projectParams.name" width="300px" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    CmeProjectDelete,
    CmeProjectList,
    CmeprojectUpdate,
    CmeProjectCreate
} from 'Services/getData.js';
export default {
    data() {
        return {
            total: 0,
            articleList: [],
            addVisible: false,
            projectParams: {
                projectId: '',
                name: ''
            },
            params: {
                page: 1,
                pageSize: 10
            },
        }
    },
    mounted() {
        this.getArticleList();
    },
    methods: {
        submit() {
            if (this.projectParams.projectId) {
                // 更新项目
                this.updateApp();
            } else {
                // 新建项目
                this.doCreateApp();
            }
        },
        async doCreateApp() {
            let cmeId = '';
            const res = await CmeProjectCreate(this.projectParams);
            if (res.status === 200 && res.data.code === 0) {
                cmeId = res.data.data;
                this.addVisible = false;
                this.pageChange(1);
                this.toEditPage({ id: cmeId, name: this.projectParams.name });
            }
        },
        async updateApp() {
            const res = await CmeprojectUpdate({
                projectId: this.projectParams.projectId,
                name: this.projectParams.name
            })
            if (res.status === 200 && res.data.code === 0) {
                this.addVisible = false;
                this.getArticleList();
                this.$message.success('更新成功');
            }
        },
        showAppDialog(item) {
            if (item) {
                // 更新项目
                this.projectParams.name = item.name;
                this.projectParams.projectId = item.id;
            } else {
                // 新建项目
                this.projectParams.name = '';
                this.projectParams.id = '';
            }
            this.addVisible = true;
        },
        toEditPage(item) {
            const id = item.id || '';
            const name = item.name || '';
            const routeData = this.$router.resolve({
                name: 'center-cme-edit',
                query: {
                    id,
                    name
                }
            });
            window.open(routeData.href, '_blank');
        },
        async getArticleList() {
            this.articleList = [];
            const res = await CmeProjectList(this.params)
            if (res.status === 200 && res.data.code === 0) {
                this.articleList = res.data.data.data;
                this.total = res.data.data.total;
            }
        },
        pageChange(page) {
            console.log(page)
            this.params.page = page;
            this.getArticleList();
        },
        deleteArticle(article) {
            let self = this;
            this.$confirm('确认删除此内容').then(async () => {
                let res = await CmeProjectDelete({
                    projectId: article.id
                });
                if (res.status === 200 && res.data.code == 0) {
                    this.$alert('删除成功');
                }
                this.getArticleList();
            }).catch((e) => {
                console.log(e);
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/manage/content.scss';
.my-content {
    .add-btn {
        margin-bottom: 20px;
    }
    .freelance-list {
        .txt {
            padding-left: 20px;
        }
    }
}
.list {
    height: 142px;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
</style>